import React from "react";
import "./Spinner2.scss";

export default function Spinner2({ color, width, height} : { color?: string, width?: string, height?: string }) {
    const style = {};
    if (color) {
        style["--spinner2-color"] = color;
    }
    if (width) {
        style["--spinner2-width"] = width;
    }
    if (height) {
        style["--spinner2-height"] = height;
    }
    
    return <div className="bwp-spinner2" style={style}></div>;
}